import { gql } from '@apollo/client'

export const SCORE_FRAGMENT = gql`
  fragment Score on Score {
    numerator
    denominator
  }
`

export const CATEGORY_SCORE_FRAGMENT = gql`
  fragment CategoryScore on CategoryScore {
    customerCasesCount
    competitorCasesCount
    category
  }
`

export const AUDIT_SCORE_FRAGMENT = gql`
  fragment AuditScore on AuditScore {
    created
    modified
    id
    questions {
      ...Score
    }
    soviScores {
      ...CategoryScore
    }
  }
  ${CATEGORY_SCORE_FRAGMENT}
  ${SCORE_FRAGMENT}
`
